<template>
  <base-modal ref="modal">
    <base-card shadow>
      <div class="sm:tw-flex sm:tw-items-start">
        <div
          class="tw-mx-auto tw-flex-shrink-0 tw-flex tw-items-center tw-justify-center tw-h-12 tw-w-12 tw-rounded-full tw-bg-red-100 sm:tw-mx-0 sm:tw-h-10 sm:tw-w-10 sm:tw--mt-1.5"
        >
          <trash-icon class="tw-h-6 tw-w-6 tw-text-red-600" />
        </div>
        <div class="tw-mt-3 tw-text-center sm:tw-mt-0 sm:tw-ml-4 sm:tw-text-left">
          <h3 class="tw-text-xl tw-font-thin">Delete Plan</h3>
          <div class="tw-mt-2 tw-font-thin tw-text-gray-600">
            <div>Are you sure you want to delete this plan?</div>
            <div>Deleting this plan will permanently remove it from the system.</div>
            <span class="tw-ml-1" v-if="organization.useCreditsSetting === true">Any credits accumulated for this plan will be deleted.</span>
          </div>
        </div>
      </div>
      <inline-error id="delete-business-member-plan-modal-error" :title="errorTitle" :message="errorMessage" :error="error" />
      <div class="sm:tw-flex sm:tw-flex-row-reverse tw-mt-4">
        <base-button @click="deletePlan" :loading="isLoading" class="tw-w-full sm:tw-w-auto sm:tw-ml-3" color="red">Delete</base-button>
        <base-button @click="hide" type="flat" class="tw-w-full sm:tw-w-auto tw-mt-2 sm:tw-mt-0" color="red">
          Cancel
        </base-button>
      </div>
    </base-card>
  </base-modal>
</template>
<script>
import { TrashIcon } from "@/assets/svgs";
import { mapGetters } from "vuex";
import InlineError from "@/components/InlineError";

export default {
  name: "BusinessMemberPlanDelete",
  components: { TrashIcon, InlineError },
  props: {
    businessId: String,
    userId: String,
    userBusinessPlanId: String,
  },
  data() {
    return {
      isLoading: false,
      errorTitle: "",
      errorMessage: "",
      error: null,
    };
  },
  computed: {
    ...mapGetters("organization", ["organization"]),
  },
  methods: {
    show() {
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    deletePlan() {
      this.isLoading = true;

      this.$axios
        .put(`/businesses/${this.businessId}/members/${this.userId}/memberplans/${this.userBusinessPlanId}/delete`)
        .then(() => {
          this.hide();
          this.EventBus.$emit("member_update");
          this.EventBus.$emit("GLOBAL_NOTIFY", { title: "Member Plan Deleted", message: "Plan was deleted successfully" });
        })
        .catch((err) => {
          this.errorTitle = "Error deleting plan";
          this.errorMessage = "Sorry, we had trouble deleting this plan. The technicians have been notified. Please try again.";
          this.error = err;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
